import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Webhooks extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Webhooks";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {

      name: null,
      description: null,
      approved: {
        is_enabled: false,
        webhook_url: null,
        webhook_key: null,
        webhook_secret: null,
        webhook_method: "POST"
      },
      declined: {
        is_enabled: false,
        webhook_url: null,
        webhook_key: null,
        webhook_secret: null,
        webhook_method: "POST"
      },
      error: {
        is_enabled: false,
        webhook_url: null,
        webhook_key: null,
        webhook_secret: null,
        webhook_method: "POST"
      },
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {


    return data;
  }
}
